import React, { useMemo } from 'react'
import { EmailConfig } from './EmailDesignSettings'

interface EmailPreviewProps {
    config: EmailConfig
    bodyHtml: string
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ config, bodyHtml }) => {
    const { header, footer, styles } = config

    // We construct a complete HTML document string to mimic what the backend might send
    // Using inline styles for email compatibility simulation
    const previewContent = useMemo(() => {
        return `
      <div style="font-family: ${styles.fontFamily}; max-width: 600px; margin: 0 auto; background-color: #f8f9fa;">
        <!-- Header -->
        <div style="background-color: ${header.backgroundColor}; padding: 20px; text-align: ${header.align};">
          ${header.logoUrl
                ? `<a href="${header.url}"><img src="${header.logoUrl}" alt="Logo" style="max-height: 50px; border: 0;" /></a>`
                : `<h2 style="margin: 0; color: #333;">Brand Logo</h2>`
            }
        </div>

        <!-- Body -->
        <div style="background-color: #ffffff; padding: 30px; color: #333333; line-height: 1.6;">
          ${bodyHtml || '<p style="color: #999;">Start typing in the editor...</p>'}
        </div>

        <!-- Footer -->
        <div style="background-color: #eeeeee; padding: 20px; text-align: center; font-size: 12px; color: #666666;">
          ${footer.socials.length > 0 ? `
            <div style="margin-bottom: 15px;">
              ${footer.socials.map(s => `<a href="${s.url}" style="margin: 0 5px; color: ${styles.primaryColor}; text-decoration: none;">${s.network}</a>`).join('')}
            </div>
          ` : ''}
          
          <p style="margin: 0 0 10px 0;">${footer.text}</p>
          
          <div style="margin-top: 15px; border-top: 1px solid #dddddd; padding-top: 10px;">
             If you no longer wish to receive these emails, you can <a href="#" style="color: ${styles.primaryColor};">${footer.unsubscribeText}</a>.
          </div>
        </div>
      </div>
    `
    }, [config, bodyHtml])

    return (
        <div className='email-preview-container border rounded bg-light p-3 h-100 overflow-auto'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
                <small className='text-muted text-uppercase fw-bold'>Live Preview</small>
                <div className='badge bg-warning text-dark'>Desktop View</div>
            </div>

            <div
                className='email-canvas bg-white shadow-sm mx-auto'
                style={{ maxWidth: '640px', minHeight: '400px' }}
                dangerouslySetInnerHTML={{ __html: previewContent }}
            />
        </div>
    )
}
